function deserializeJSON(input) {
  return JSON.parse(input);
}

export default deserializeJSON;
